export abstract class BaseResponse {
  ErrorCode?: any;
  IsError?: boolean;
  result?: number;
  message?: string;
  data?: any;
}



// WEBPACK FOOTER //
// ./src/app/response/internal/baseresponse.ts